import { gql } from '@apollo/client'

export const GET_CREATION_AI_DESCRIPTION_RESULT = gql`
  query CreationAiDescriptionResult($fileAiDescriptionId: ID!) {
    creationAiDescriptionResult(fileAiDescriptionId: $fileAiDescriptionId) {
      status
      result
    }
  }
`
